import { Injectable } from "@angular/core";
import {
	AppConfigService,
	BaseService,
	Dictionary,
} from "helio-games-core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { ServiceController } from "../service-controller.urls";
import { AgentSalesStatistics } from "../models/agent-sales-statistics.model";
import { retailApiService } from "./retail-agent.service";

@Injectable({
	providedIn: "root",
})
export class AgentStatisticsService extends BaseService {
	constructor(
		protected http: HttpClient,
		private appConfigService: AppConfigService,
		private authService: AuthService
	) {
		super(
			http,
			ServiceController.AGENT_STATISTICS,
			retailApiService(appConfigService.serviceBaseURL)
		);
	}

	getSalesStatistics(
		dateFrom: Date,
		dateTo: Date
	): Observable<AgentSalesStatistics> {
		const authHeaderValue = `${this.authService.authTokenData.token_type} ${this.authService.authTokenData.access_token}`;

        const searchParams = new HttpParams()
			.set('dateFrom', dateFrom.toISOString())
			.set('dateTo', dateTo.toISOString());

		const headers = new Dictionary<string>({
			Authorization: authHeaderValue,
		});

		return this.get<AgentSalesStatistics>('', [], searchParams, {
			headersValues: headers,
			appendToDefaultHeaders: true,
		});
	}
}
